const PREFIX = 'https://datadesk-prod-origin.californiatimes.com';

export function getStateUrl(date: string, postal: string, prefix = PREFIX) {
  return new URL(
    `projects/elections-data/${date}/${postal}.json`,
    prefix
  ).toString();
}

export const getCountyUrl = getStateUrl;

export function getSummaryUrl(date: string, prefix = PREFIX) {
  return new URL(
    `projects/elections-data/${date}/summary.json`,
    prefix
  ).toString();
}

export function getFullStateUrl(date: string, postal: string, prefix = PREFIX) {
  return new URL(
    `projects/elections-data/${date}/${postal}-full.json`,
    prefix
  ).toString();
}

export function getTrendsUrl(date: string, prefix = PREFIX) {
  return new URL(
    `projects/elections-data/${date}/trends.json`,
    prefix
  ).toString();
}

export function getOfficeRaceUrl(
  date: string,
  office: string,
  prefix = PREFIX
) {
  return new URL(
    `projects/elections-data/${date}/${office}.json`,
    prefix
  ).toString();
}

export function getGeographyUrl(
  postal: string,
  geographyType = 'states',
  prefix = PREFIX
) {
  return new URL(
    `projects/elections-data/2020-11-03/geographies/${geographyType}/${postal}.json`,
    prefix
  ).toString();
}
